/**
 * Yotpo Reviews – product page layout adjustments
 * Moves Write A Review button and review date between panels for desktop/mobile.
 * Attaches click-to-scroll from .yotpo-widget-instance to #yotpo-reviews-main-widget.
 * Used by sections/product-information.liquid.
 */
(function () {
  var boundScrollInstances = new WeakSet();

  /** @param {Element} instance */
  function hasZeroReviews(instance) {
    var btn = instance.querySelector(
      'button.yotpo-sr-bottom-line-button[aria-label*="total 0 reviews"]',
    );
    return Boolean(btn);
  }

  function openWriteReviewForm() {
    var reviewsWidget = document.getElementById('yotpo-reviews-main-widget');
    if (!reviewsWidget) return;
    var writeBtn = /** @type {HTMLElement|null} */ (
      reviewsWidget.querySelector('.yotpo-new-review-btn-wrapper .yotpo-new-review-btn')
    );
    if (!writeBtn) return;
    var btn = writeBtn;
    setTimeout(function () {
      btn.click();
    }, 600);
  }

  /** @param {Element} instance */
  function isReviewsWidgetInstance(instance) {
    return Boolean(
      instance.querySelector('#yotpo-reviews-main-widget') ||
      instance.closest('#yotpo-reviews-main-widget'),
    );
  }

  function updateScrollAffordance() {
    var instances = document.querySelectorAll('.yotpo-widget-instance');
    instances.forEach(function (instance) {
      /** @type {HTMLElement} */ (instance).style.cursor = isReviewsWidgetInstance(instance)
        ? ''
        : 'pointer';
    });
  }

  function attachScrollToReviews() {
    var instances = document.querySelectorAll('.yotpo-widget-instance');
    instances.forEach(function (instance) {
      if (boundScrollInstances.has(instance)) return;
      boundScrollInstances.add(instance);
      instance.addEventListener('click', function (event) {
        var target = /** @type {Element | null} */ (event.target);
        if (target && target.closest && target.closest('#yotpo-reviews-main-widget')) {
          return;
        }
        if (hasZeroReviews(instance)) {
          openWriteReviewForm();
          return;
        }
        var reviewsWidget = document.getElementById('yotpo-reviews-main-widget');
        if (reviewsWidget) {
          reviewsWidget.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });
    updateScrollAffordance();
  }
  function moveYotpoReviewButton() {
    var summary = document.querySelector('.yotpo-bottom-line-summary');
    var btnWrapper = document.querySelector('.yotpo-new-review-btn-wrapper');
    if (summary && btnWrapper && summary.parentNode && summary.nextElementSibling !== btnWrapper) {
      summary.parentNode.insertBefore(btnWrapper, summary.nextSibling);
      return true;
    }
    return false;
  }

  function placeDateInInfoBox() {
    var reviews = document.querySelectorAll('#yotpo-reviews-main-widget .yotpo-review');
    var moved = 0;
    reviews.forEach(function (review) {
      var reviewer = review.querySelector('.yotpo-review-left-panel .yotpo-reviewer');
      var dateEl = review.querySelector('.yotpo-review-date');
      if (reviewer && dateEl && !reviewer.contains(dateEl)) {
        reviewer.appendChild(dateEl);
        moved++;
      }
    });
    return moved > 0;
  }

  // Below ~480px Yotpo renders the key-value sizes inside the center panel's
  // mobile questions panel instead of the left panel, so it falls outside the
  // grey info box. Move it into the left panel (after the reviewer) whenever it
  // isn't already there, leaving the range bars in the main content column.
  function placeSizesInInfoBox() {
    var reviews = document.querySelectorAll('#yotpo-reviews-main-widget .yotpo-review');
    var moved = 0;
    reviews.forEach(function (review) {
      var left = review.querySelector('.yotpo-review-left-panel');
      var keyValue = review.querySelector('.yotpo-review-key-value-question');
      if (left && keyValue && !left.contains(keyValue)) {
        left.appendChild(keyValue);
        moved++;
      }
    });
    return moved > 0;
  }

  function styleKeyValueRows() {
    var desktop = window.innerWidth > 1079;
    var blocks = document.querySelectorAll(
      '#yotpo-reviews-main-widget .yotpo-review-key-value-question',
    );
    blocks.forEach(function (el) {
      var block = /** @type {HTMLElement} */ (el);
      if (!desktop) {
        block.style.removeProperty('grid-template-rows');
        return;
      }
      var titles = block.querySelectorAll('.yotpo-custom-questions-title').length;
      if (titles > 0) {
        block.style.gridTemplateRows = 'repeat(' + titles + ', auto)';
      }
    });
  }

  function styleRangeQuestionBars() {
    var bars = document.querySelectorAll(
      '.yotpo-custom-questions-range-question-wrapper .yotpo-progress-bar',
    );
    bars.forEach(function (bar) {
      var score = /** @type {HTMLElement | null} */ (
        bar.querySelector('.yotpo-progress-bar-score')
      );
      if (!score) return;

      var left = parseFloat(score.style.marginLeft) || 0;
      var width = parseFloat(score.style.width) || 0;
      var fillEnd = left + width;
      var bucket = Math.min(5, Math.max(1, Math.ceil(fillEnd / 20)));
      var nextBucket = String(bucket);

      if (bar.getAttribute('data-fit-bucket') !== nextBucket) {
        bar.setAttribute('data-fit-bucket', nextBucket);
      }
    });
  }

  function runYotpoLayout() {
    moveYotpoReviewButton();
    placeDateInInfoBox();
    placeSizesInInfoBox();
    styleKeyValueRows();
  }

  function applyYotpoAdjustments() {
    runYotpoLayout();
    styleRangeQuestionBars();
    attachScrollToReviews();
  }

  var observer = new MutationObserver(scheduleApply);
  var scheduled = false;

  function observeYotpo() {
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      observer.disconnect();
      applyYotpoAdjustments();
      observeYotpo();
    });
  }

  applyYotpoAdjustments();
  observeYotpo();
  window.addEventListener('resize', scheduleApply);
})();
